import { IZone } from "interfaces/zone.interface";

import { CreateZoneForm } from "./forms/CreateZoneForm";

type ZoneCreatePageProps = {
  zones: IZone[];
};

export function ZoneCreatePage({ zones }: ZoneCreatePageProps) {
  return <CreateZoneForm zones={zones} />;
}
